document.addEventListener('copy', function(event) {
    const targetElement = event.target;
    if (targetElement.matches('.article-detail, .article-detail *')) {
        const pagelink = "\nZdroj: " + document.location.href;
        event.clipboardData.setData('text', document.getSelection() + pagelink);
        ga('p.send', 'event', 'copy-text', document.location.href, document.getSelection().toString());
        event.preventDefault();
    }
});

window.addEventListener('load',function (e) {
    let elements = document.querySelectorAll('.box-perex');

    elements.forEach((element) => {
        addTargetBlankToLinks(element);
    });
});

function addTargetBlankToLinks(element) {
    let links = element.querySelectorAll('a');
    links.forEach((link) => {
        if(!link.hasAttribute('target') && !link.classList.contains('img-in-text')) {
            link.setAttribute('target','_blank');
        }
    });
}
